<template>
  <div class="author">
    <div class="author__portrait">
      <img
        :src="portrait"
        :alt="name"
      >
    </div>

    <div class="author__details">
      <p class="author__name" v-html="name" />
      <p class="author__title" v-html="title" />
      <p class="author__company" v-html="company" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    portrait: {
      type: String,
      default: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='rgb(27,30,33)' viewBox='0 0 24 24'%3E%3Cpath d='M20.822 18.096c-3.439-.794-6.64-1.49-5.09-4.418 4.72-8.912 1.251-13.678-3.732-13.678-5.082 0-8.464 4.949-3.732 13.678 1.597 2.945-1.725 3.641-5.09 4.418-3.073.71-3.188 2.236-3.178 4.904l.004 1h23.99l.004-.969c.012-2.688-.092-4.222-3.176-4.935z'/%3E%3C/svg%3E"
    },
    name: {
      type: String,
      default: '-'
    },
    title: {
      type: String,
      default: '-'
    },
    company: {
      type: String,
      default: '-'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.author {
  @include font('content--md', $black, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 1rem 0;
  font-weight: 500;

  @media screen and (min-width: $breakpointLg) {
    @include font('content--lg', $black, 0.9);
    margin: 1rem 0;
    font-weight: 500;
  }

  &__portrait {
    background-color: rgba($white, 0.9);
    width: 64px;
    height: 64px;
    border-radius: 999px;

    img {
      width: 60px;
      height: 60px;
      border-radius: 999px;
      padding: 2px;
    }

    @media screen and (min-width: $breakpointLg) {
      width: 68px;
      height: 68px;

      img {
        width: 64px;
        height: 64px;
      }
    }
  }

  &__details {
    margin-left: 2rem;
    text-align: left;
  }

  &__name, &__title, &__company {
    margin: 0;
  }

  &__title, &__company {
    color: rgba($black, 0.6);
  }
}

</style>